import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["existingMember", "newMember", "radio"];

  connect() {
    this.toggle();
  }

  toggle() {
    const selectedValue = this.radioTargets.find(
      (radio) => radio.checked,
    )?.value;

    if (selectedValue === "existing") {
      this.existingMemberTarget.style.display = "block";
      this.newMemberTarget.style.display = "none";
      this.disableNewMemberFields(true);
    } else {
      this.existingMemberTarget.style.display = "none";
      this.newMemberTarget.style.display = "block";
      this.disableNewMemberFields(false);
    }
  }

  disableNewMemberFields(disabled) {
    const inputs = this.newMemberTarget.querySelectorAll(
      "input, select, textarea",
    );
    inputs.forEach((input) => {
      if (disabled) {
        input.setAttribute("disabled", "disabled");
      } else {
        input.removeAttribute("disabled");
      }
    });
  }
}
